import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import SandboxHost from './components/sandbox-host'
import './sandbox.css'

const container = document.getElementById('root')
if (container === null) throw new Error('Root container missing in sandbox HTML.')

createRoot(container).render(
  <StrictMode>
    <SandboxHost />
  </StrictMode>
)
